import {useQuery} from '@tanstack/react-query'
import {getNotices} from '../../api/notices'
import {queryKeys} from '../../constants/queryKey'

function useGetNoticesQuery(params: IGetNotices) {
  return useQuery<INotices>([queryKeys.notices, params.start, params.noticeType], () => getNotices(params), {})
}

export default useGetNoticesQuery
